import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import * as _ from 'lodash';
import { Classroom360Service } from '../../classroom360/classroom360.service';
import { LoginService } from '../../shared-modules/login/login.service';
import { Portal } from '../portal.model';
import { FavoritePreferences } from '../user-preferences/favorite-prefences.model';
import { PortalMenuItem } from '../user-preferences/portal-menu-preferences.model';
import { UserPreferencesService } from '../user-preferences/user-preferences.service';
import { FavoritePortal } from './favorite-portals.model';

@Component({
    selector: 'app-favorites',
    templateUrl: './favorites.component.html',
    styleUrls: ['./favorites.component.css']
})
export class FavoritesComponent implements OnInit {
    @Input() staffAssignedPortals: Portal[];
    @Input() editFavorites: boolean;
    @Input() isDefaultPreferences: boolean;
    @ViewChild('menu', { static: true }) menuRef: ElementRef;
    parentAssignedPortals: any[];
    rowDetailExpand: boolean[] = [];
    favoritesPreferences: FavoritePreferences;
    selectedFavoritesPortals: FavoritePortal[] = [];
    V10: boolean;

    constructor(private userPreferencesService: UserPreferencesService,
        private classroom360Service: Classroom360Service,
        private loginService: LoginService,
        private dialogRef: MatDialogRef<FavoritesComponent>) {
    }

    ngOnInit() {
        this.V10 = this.loginService.LoginSettings.V10;
        if (!this.V10) {
            this.setFavorites();
        }
    }

    portalCheckboxClick(portal: Portal) {
        if (this.V10) {
            const index: number = this.staffAssignedPortals.findIndex(sap => sap.PortalName == portal.PortalName
                && sap.GroupName == portal.GroupName
                && sap.ParentModule == portal.ParentModule
                && sap.PortalDescription.split('?')[0] == portal.PortalDescription.split('?')[0]);

            if (index > -1) {
                this.staffAssignedPortals[index].IsFavorite = portal.IsFavorite;
            }
        }
        else {
            if (portal.Selected) {
                const favExists: boolean = this.selectedFavoritesPortals.filter(favPortal =>
                    favPortal.Id == portal.Id
                    || ((favPortal.Id == null || favPortal.Id == 0)
                        && favPortal.GroupName == portal.GroupName
                        && favPortal.PortalDescription.split('?')[0] == portal.PortalDescription.split('?')[0]
                        && favPortal.PortalModule == portal.ParentModule
                        && favPortal.PortalName == portal.PortalName)).length != 0;

                if (!favExists) {
                    const newFavorite: FavoritePortal = {
                        ParentPortalName: '',
                        PortalDescription: portal.PortalDescription,
                        PortalName: portal.PortalName,
                        PortalModule: portal.ParentModule,
                        GroupName: portal.GroupName,
                        Id: portal.Id
                    };

                    this.selectedFavoritesPortals.push(newFavorite);
                }
            }
            else {
                const favIndex: number = this.selectedFavoritesPortals.findIndex(favPortal =>
                    favPortal.Id == portal.Id
                    || ((favPortal.Id == null || favPortal.Id == 0)
                        && favPortal.GroupName == portal.GroupName
                        && favPortal.PortalDescription.split('?')[0] == portal.PortalDescription.split('?')[0]
                        && favPortal.PortalModule == portal.ParentModule
                        && favPortal.PortalName == portal.PortalName));

                if (favIndex != -1) {
                    this.selectedFavoritesPortals.splice(favIndex, 1);
                }
            }
        }
    }

    setFavorites() {
        // Get the Favorites
        if (!this.isDefaultPreferences) {
            this.favoritesPreferences = this.userPreferencesService.favoritesPreferences;
            if (this.favoritesPreferences != null) {
                this.selectedFavoritesPortals = _.cloneDeep(this.favoritesPreferences.FavoritePortals);
            }
        }
        else {
            this.userPreferencesService.getUserPreferences(0, '/OneSISFavorites', 0, '', this.isDefaultPreferences).subscribe(data => {
                this.favoritesPreferences = JSON.parse(data[0]);

                this.staffAssignedPortals.forEach(portal => {
                    portal.isDefaultSelected = false;
                });

                this.favoritesPreferences.FavoritePortals.forEach(favPortal => {
                    const staffPortal: Portal = this.staffAssignedPortals.find(portal =>
                        favPortal.Id == portal.Id
                        || ((favPortal.Id == null || favPortal.Id == 0)
                            && favPortal.GroupName == portal.GroupName
                            && favPortal.PortalDescription.split('?')[0] == portal.PortalDescription.split('?')[0]
                            && favPortal.PortalModule == portal.ParentModule
                            && favPortal.PortalName == portal.PortalName));

                    this.selectedFavoritesPortals.push(favPortal);
                    if (staffPortal) {
                        staffPortal.isDefaultSelected = true;
                    }
                });
            }, err => {
                console.log(err);
            }, () => {
            });
        }
    }

    closeClick() {
        // POST: Close the dialog
        this.dialogRef.close('Close was clicked.');
    }

    expandAllClick(expand: boolean) {
        this.menuRef['collapseExpandAll'](expand);
    }

    saveClick() {
        // POST: Wraps the object, converts to XML and saves the preference

        if (this.V10) {
            this.classroom360Service.updateStaffAssignedPortals(this.staffAssignedPortals);
            this.userPreferencesService.updateFavoritePortals(this.staffAssignedPortals, false).subscribe(data => {

            });

            this.closeClick();
        }
        else {
            if (this.selectedFavoritesPortals != null) {
                if (this.favoritesPreferences == null) {
                    this.favoritesPreferences = new FavoritePreferences();
                }
                this.favoritesPreferences.FavoritePortals = this.selectedFavoritesPortals;
                const xmlStream: string[] = [];
                const prefs: FavoritePreferences = {
                    FavoritePortals: this.favoritesPreferences.FavoritePortals
                };
                xmlStream.push(JSON.stringify(prefs));
                this.userPreferencesService.saveUserPreferences(0, '/OneSISFavorites', xmlStream, 0, '', this.isDefaultPreferences).subscribe(res => {
                    if (!this.isDefaultPreferences) {
                        this.userPreferencesService.favoritesPreferences = this.favoritesPreferences;
                    }
                }, err => {
                    console.log(err);
                }, () => {
                    this.closeClick();
                });

            }
        }
    }

    expandGroup($event: any, portalMenu: PortalMenuItem) {
        $event.stopPropagation();
        portalMenu.Expanded = portalMenu.Expanded == 1 ? 0 : 1;
    }

    togglePortal(portal: Portal) {
        portal.Selected = !portal.Selected;
    }
}
